// extracted by mini-css-extract-plugin
export default {"h1":"Header_h1__XcSp-","h2":"Header_h2__7GSjd","h3":"Header_h3__z6RL5","h4":"Header_h4__kR0iG","h5":"Header_h5__9af0l"};